module.exports = __webpack_public_path__ + "img/lp.c272ded2.jpg";